export default __webpack_public_path__ + "static/media/banner1.1f12db86.jpg";